
waitForElementToExist('.new-newsletter').then(element => {
    const firstForm = document.querySelector('.first-form');
    const nomeInput = document.querySelector('.first-form #adult-name');
    const emailInput = document.querySelector('.first-form #email');

    function validateInputs() {
        const isNomeFilled = nomeInput && nomeInput.value.trim() !== '';
        const isEmailFilled = emailInput && emailInput.value.trim() !== '';
    }

    if (nomeInput && emailInput) {
        nomeInput.addEventListener('input', validateInputs);
        emailInput.addEventListener('input', validateInputs);
        validateInputs();
    }

    var newNewslleter = new NewsLetter();

    $('.first-form').submit(function (event) {
        event.preventDefault();

        var data = {
            'email': $(this).closest('.new-newsletter-content').find('.first-form #email').val(),
            'nome': $(this).closest('.new-newsletter-content').find('.first-form #adult-name').val(),
        }

        var action = newNewslleter.addEmail(data);
    });

    var newsLetterBox = $('.new-newsletter-modal');

    $(newNewslleter).bind('onSuccessAddEmailNewsLetter', function (event, data) {
        event.preventDefault();
        newsLetterBox.addClass('active');
        newsLetterBox.html('Obrigado Por Participar, Confira Seu E-mail!').addClass('success');

        setTimeout(function () {
            newsLetterBox.removeClass('active');
            newsLetterBox.removeClass('success');
        }, 4000);
    }).bind('onFailAddEmailNewsLetter500', function (event, data, jqXHR, textStatus, errorThrown) {
        newsLetterBox.addClass('active');
        newsLetterBox.html('O email já está cadastrado!').addClass('error');

        setTimeout(function () {
            newsLetterBox.removeClass('active');
            newsLetterBox.removeClass('error');
        }, 4000);

        newsLetterBox.addClass('is-active');
        newsLetterBox.html(data.email[0]).addClass('error');
    }).bind('onFailAddEmailNewsLetter', function (event, data, jqXHR, textStatus, errorThrown) {
        event.preventDefault();
        console.log('Error: ', data);
        newsLetterBox.addClass('active');
        newsLetterBox.html('Endereço de e-mail já está cadastrado').addClass('error');

        setTimeout(function () {
            newsLetterBox.removeClass('active');
            setTimeout(function () { newsLetterBox.removeClass('error') }, 1220);

            $('#email').attr('placeholder', 'Email').removeClass('is-error');
        }, 4000);
    });
});